import { Toggle } from '@outdoorsyco/bonfire';
import React from 'react';

interface IRequirementItemProps {
  value: boolean;
  label: string;
  onChange: (isSelected: boolean) => void;
  icon: React.ReactNode;
}

const RequirementItem: React.FC<IRequirementItemProps> = ({ value, onChange, label, icon }) => {
  return (
    <span className="flex items-center justify-start mb-4 text">
      <div className="flex items-center ml-auto">{icon}</div>
      <Toggle
        ariaLabel={label}
        className="w-full"
        content={{ label }}
        contentOnLeft
        onChange={onChange}
        isSelected={value}
      />
    </span>
  );
};

export default RequirementItem;
